var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contain",class:{change: _vm.ifMenu},on:{"click":function($event){return _vm.$emit('openClose')}}},[_c('div',{staticClass:"bar1"}),_c('div',{staticClass:"bar2"}),_c('div',{staticClass:"bar3"})])}
var staticRenderFns = []

export { render, staticRenderFns }